import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { GroupEntity } from './group.entity';
import { ItemEntity } from './item.entity';

@Index('fk_item__id', ['fkItemId'], {})
@Index('group_item_uindex', ['fkItemId', 'fkGroupId'], { unique: true })
@Index(
	'item_group_fkItemId_deletedUserId_fkGroupId',
	['deletedUserId', 'fkItemId', 'fkGroupId'],
	{},
)
@Index(
	'item_group_itemExternalId_deletedDate',
	['itemExternalId', 'deletedDate'],
	{},
)
@Index('idx_item_group_group_deleted', ['fkGroupId', 'deletedDate'], {})
@Entity('item_group')
export class ItemGroupEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'itemExternalId', nullable: true, length: 64 })
	public itemExternalId!: string | null;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'fk_group__id', unsigned: true })
	public fkGroupId!: number;

	// Provenance stamp: set when this membership was flowed down from the named
	// parent product's membership. Cascade removal only removes stamped rows, so
	// a membership added directly to the variant is never touched.
	@Column('int', {
		name: 'fk_item__id_viaParent',
		nullable: true,
		unsigned: true,
	})
	public fkItemIdViaParent!: number | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => GroupEntity, (group) => group.itemGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_group__id', referencedColumnName: 'id' }])
	public group!: GroupEntity;
}
